<template>
  <div class="table-holder table-mondelez mr-3" v-if="showMondelez">
    <table>
      <tbody>
        <tr class="table-title">
          <td colspan="3">Maior Risco Mondelez</td>
        </tr>
        <tr class="table-header">
          <td>Sev.</td>
          <td>Prob.</td>
          <td>Res.</td>
        </tr>
        <tr>
          <td>{{ maxMetrics.mondelez_severity || '-' }}</td>
          <td>{{ maxMetrics.mondelez_probability || '-' }}</td>
          <td
            :style="{
              backgroundColor: getMondelezLevelColor(
                maxMetrics.max_mondelez_result,
              ),
            }"
          >
            {{ maxMetrics.max_mondelez_result || '-' }} ({{
              maxMetrics.max_mondelez_result_label || '-'
            }})
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="table-holder table-iso-13849-1 mr-3">
    <table>
      <tbody>
        <tr
          class="table-title clickable"
          @click="showSingleImage(METRIC_IMAGES.iso138491)"
        >
          <td colspan="5">Categoria Requerida ISO 13849-1</td>
        </tr>
        <tr class="table-header">
          <td
            class="clickable"
            @click="showSingleImage(METRIC_IMAGES.iso138491_quesitos)"
          >
            Sev.
          </td>
          <td
            class="clickable"
            @click="showSingleImage(METRIC_IMAGES.iso138491_quesitos)"
          >
            Exp.
          </td>
          <td
            class="clickable"
            @click="showSingleImage(METRIC_IMAGES.iso138491_quesitos)"
          >
            Prob.
          </td>
          <td
            class="clickable"
            @click="showSingleImage(METRIC_IMAGES.iso138491a)"
          >
            Nível Perf.
          </td>
          <td>Cat 14153</td>
        </tr>
        <tr>
          <td>{{ maxMetrics.iso_138491_severity || '-' }}</td>
          <td>{{ maxMetrics.iso_138491_frequency || '-' }}</td>
          <td>{{ maxMetrics.iso_138491_prevention || '-' }}</td>
          <td>{{ maxMetrics.iso_138491_result || '-' }}</td>
          <td>{{ maxMetrics.cat14153_result || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="table-holder table-max-hrn mr-3">
    <table>
      <tbody>
        <tr
          class="table-title clickable"
          @click="showSingleImage(METRIC_IMAGES.hrn)"
        >
          <td colspan="5">Maior Risco HRN</td>
        </tr>
        <tr class="table-header">
          <td class="clickable" @click="showSingleImage(METRIC_IMAGES.hrn_po)">
            PO
          </td>
          <td class="clickable" @click="showSingleImage(METRIC_IMAGES.hrn_gpd)">
            GPD
          </td>
          <td class="clickable" @click="showSingleImage(METRIC_IMAGES.hrn_fe)">
            FE
          </td>
          <td class="clickable" @click="showSingleImage(METRIC_IMAGES.hrn_np)">
            NP
          </td>
          <td>RES</td>
        </tr>
        <tr>
          <td>{{ maxMetrics.max_po || '-' }}</td>
          <td>{{ maxMetrics.max_gpd || '-' }}</td>
          <td>{{ maxMetrics.max_fe || '-' }}</td>
          <td>{{ maxMetrics.max_np || '-' }}</td>
          <td
            :class="{ unacceptable: maxMetrics.max_hrn_level === 8 }"
            :style="`background-color: ${getHrnLevelColor(
              maxMetrics.max_hrn_level,
            )}`"
            width="60px"
          >
            {{ maxMetrics.max_hrn_result || '-' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import useHrn from '@/modules/Hrn.js'
  import useMondelez from '@/modules/Mondelez.js'
  import useImageViewer from '@/modules/ImageViewer.js'

  import { METRIC_IMAGES } from '@/constants/images.constants.js'

  export default {
    setup() {
      const { getHrnLevelColor } = useHrn()
      const { getMondelezLevelColor } = useMondelez()
      const {
        showSingleImage,
        showImageIndex,
        setVisible,
        images,
        imageVisible,
        imageIndex,
      } = useImageViewer()

      return {
        getHrnLevelColor,
        getMondelezLevelColor,
        showImageIndex,
        showSingleImage,
        setVisible,
        images,
        imageVisible,
        imageIndex,
        METRIC_IMAGES,
      }
    },
    props: {
      maxMetrics: {
        type: Object,
        required: true,
      },
      showMondelez: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  table,
  tr,
  td {
    border: 1px solid #ccc;
  }

  table {
    border-collapse: collapse;

    td {
      padding: 5px;
      text-align: center;
    }

    tr:not(.table-title):not(.table-header) td {
      font-size: 0.9rem;
    }

    .table-title {
      background-color: #ccc;
      text-align: center;
      font-weight: bold;
    }

    .table-header {
      text-align: center;
    }
  }

  .table-holder {
    display: inline-block;
  }
</style>
